import { render, staticRenderFns } from "./NewOrdersList.vue?vue&type=template&id=b6c22cf8&scoped=true&"
import script from "./NewOrdersList.vue?vue&type=script&lang=js&"
export * from "./NewOrdersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c22cf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6c22cf8')) {
      api.createRecord('b6c22cf8', component.options)
    } else {
      api.reload('b6c22cf8', component.options)
    }
    module.hot.accept("./NewOrdersList.vue?vue&type=template&id=b6c22cf8&scoped=true&", function () {
      api.rerender('b6c22cf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Orders/NewOrdersList.vue"
export default component.exports